
import { SetStateAction, useState,useEffect} from 'react';
import Layout from '../../components/layoutMasterConfig/layoutMaster';
import '../../components/dashboard/datatable/datatable.css';
import edit from '../../components/dashboard/img/favicon/editar.png';

import DataTable, { TableColumn } from 'react-data-table-component';
import { Zip_Code_Api } from '../../services/zip_code_api/zip_code_api';
import { setupAPIclient } from '../../services/setupAPIclientAuth';
import { toast } from 'react-toastify';
import { apiClientMater } from '../../services/setupClientMaster/apiClientMaster';
 


  interface Post {
    id: number;
    name: string;
    email: string;
    number: number;
    address: string; 
    car_model: string; 
    city: string; 
    createdAt: string; 
    is_registered_in_app: boolean; 
    pet_quantity: number; 
    postal_code: string; 
    state: string; 
    transport_type: string; 
    updatedAt: string;
    neighborhood:string;    number_active:boolean

  }

  type DataRow = {
    id: number;
    name: string;
    email: string;
    number: number;
    address: string; 
    car_model: string; 
    city: string; 
    createdAt: string; 
    is_registered_in_app: boolean; 
    pet_quantity: number; 
    postal_code: string; 
    state: string; 
    transport_type: string; 
    updatedAt: string;    neighborhood:string;
    number_active:boolean

  };
  
function ConfigMasterDrivePage() {

  const [getData, setgetData] = useState<DataRow[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [filterText, setFilterText] = useState(""); 
  const [showFormUpdate, setShowFormUpdate] = useState(false);
  const [Iduser, setShowIduser] = useState(0);



  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    neighborhood: '',
    postal_code: '',
    city: '',
    state: '',
    car_model: '',
    is_registered_in_app: false,
    pet_quantity: 0,
    transport_type: '',
    password: '',
    number: '',
    active: false,
  });
  const handleChange = (e: { target: { name: any; value: any; type: any; checked: any; }; }) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };
  // Função para formatar número de telefone
  function maskPhone(e: React.ChangeEvent<HTMLInputElement>){
    let phone = e.target.value;
    phone = phone.replace(/\D/g, ''); // Remove tudo o que não é número
    phone = phone.replace(/(\d{2})(\d)/, '($1) $2');
    phone = phone.replace(/(\d{5})(\d{1,4})$/, '$1-$2');
      setFormData({ ...formData, number: phone });
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  

    if(!formData.email){
      return toast.warning("O email não pode estar vazio")
    }else if(!formData.number){
      return toast.warning("O número de telefone não pode estar vazio")
    } else if(!formData.password){
      return toast.warning("A senha não pode estar vazia.")
    }else {

      const loadingToast = toast.info("Processando... aguarde", {
        autoClose: false, 
      });
  
      toast.dismiss(loadingToast);
      
      try {
        const ApiClient = setupAPIclient();
        const response = await ApiClient.post("/register_user", {
          "name": formData.name,
          "email": formData.email,
          "address": formData.address,
          "neighborhood": formData.neighborhood,
          "postal_code": formData.postal_code,
          "city": formData.city,
          "state": formData.state,
          "number_active": false,
          "number": formData.number,
          "password": formData.password,
          "access_permission_request": false,
          "car_model": formData.car_model,
          "is_registered_in_app": formData.is_registered_in_app,
          "pet_quantity": Math.floor(formData.pet_quantity),
          "transport_type": formData.transport_type,
        });
        if (response.data.error) {
          toast.warning("Existe um erro no formulário ou este usuário já existe");
        } else {
          toast.success("Cadastrado com sucesso!");

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      } catch (error) {
        // Remove o toast de loading em caso de erro
        toast.dismiss(loadingToast);
        toast.error("Erro ao cadastrar usuário. Tente novamente.");
      }
    }




  
  }
  async function handleChangePostalcode(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
    setFormData({
      ...formData,                
      postal_code: e.target.value, 
    });
    console.log("dados --  " + e.target.value)
    const apiclient =  Zip_Code_Api(e.target.value)
    const response =  await apiclient.get("")
    if(response && response.data ){
      setFormData({
        ...formData,neighborhood: response.data.bairro,
        state: response.data.estado,
        city: response.data.localidade,
        address: response.data.logradouro
      });
    } 
  }
  const columns: TableColumn<DataRow>[] = [
    {
      name: "Nome",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "E-mail",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Telefone",
      selector: (row) => row.number,
      sortable: true,
    },
    {
      name: 'Ações',
      cell: (row: { id: number }) => (
        <button className='btn'  onClick={() => handleButtonUpdate(row.id)}>         
          <img src={edit} width={20} alt="Editar" />
        </button>
      ),
      ignoreRowClick: true, 
      allowOverflow: true,
      button: true
    },
  ];
  const handleButtonUpdate = (id: number) => {




      const selectedItem = getData.find((item) => item.id === id);

      console.log(`Item com ID ${id} foi clicado! ${selectedItem?.city}`);
  
  
      setShowIduser(id)
  
      setFormData({
        name: selectedItem?.name ?? '',
        email: selectedItem?.email ?? '',
        address: selectedItem?.address ?? '',
        neighborhood: selectedItem?.neighborhood ?? '',
        postal_code: selectedItem?.postal_code ?? '',
        city: selectedItem?.city ?? '',
        state: selectedItem?.state ?? '',
        car_model: selectedItem?.car_model ?? '',
        is_registered_in_app: selectedItem?.is_registered_in_app ?? false,
        pet_quantity: selectedItem?.pet_quantity ?? 0,
        transport_type: selectedItem?.transport_type ?? '',
        password: '', // Você pode ajustar isso conforme necessário
        number: String(selectedItem?.number ?? ''), 
        active: selectedItem?.active ?? false,
      });
  
  
      setShowFormUpdate(true)


  
  }
  const filteredData = getData.filter(
    (item) =>
      item.name?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.email?.toLowerCase().includes(filterText.toLowerCase()) 
  );
  const handleClearData = () => {
    // Resetando o formData para garantir que esteja vazio
    setFormData({
      name: '',
      email: '',
      address: '',
      neighborhood: '',
      postal_code: '',
      city: '',
      state: '',
      car_model: '',
      is_registered_in_app: false,
      pet_quantity: 0,
      transport_type: '',
      password: '',
      number: '',
      active: false,
    });

    setShowModal(true)
  }
  const handleSubmitUpdate = async () => {



      // alert(Iduser)



    if(!formData.email){
      return toast.warning("O email não pode estar vazio")
    }else if(!formData.number){
      return toast.warning("O número de telefone não pode estar vazio")
    } else {
      const loadingToast = toast.info("Processando... aguarde", {
        autoClose: false, 
      });
      toast.dismiss(loadingToast);


      try {
        const ApiClient = apiClientMater();
        
        const response = await ApiClient.post(`/crud/update/User/${Iduser}`, {
            id: Iduser,
            name: formData.name,
            address: formData.address,
            neighborhood: formData.neighborhood,
            postal_code: formData.postal_code,
            city: formData.city,
            state: formData.state,
            number_active: false,
            number: formData.number,
            access_permission_request: false,
            car_model: formData.car_model,
            is_registered_in_app: formData.is_registered_in_app,
            pet_quantity: Math.floor(formData.pet_quantity),
            transport_type: formData.transport_type,
        });
    
        // Verifica se a resposta da API indica sucesso
        if (response.status >= 200 && response.status < 300) {
            toast.success("Atualizado com sucesso!");

            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else {
            throw new Error(`Erro inesperado: ${response.status}`);
        }
    } catch (error) {
        console.error("Erro ao atualizar usuário:", error);
    
        // Remove o toast de loading (caso esteja sendo usado)
        toast.dismiss(loadingToast);
    
        // Exibe uma mensagem de erro apropriada
        toast.error("Erro ao atualizar o usuário. Tente novamente.");
    }
    }

   
    
  }
  useEffect(() => {
    const handlegetActivisionData = async () => {
      const ApiClient = apiClientMater();
      const response = await ApiClient.post("/crud/User");

      const formattedData = response.data.map((item: any) => ({
        id: item.id,
        name: item.name,
        email: item.email,
        number: item.number,
        address: item.address, 
        car_model: item.car_model, 
        city: item.city,
        createdAt: item.createdAt, 
        is_registered_in_app: item.is_registered_in_app, 
        pet_quantity: item.pet_quantity, 
        postal_code: item.postal_code,
        state: item.state, 
        transport_type: item.transport_type,
        updatedAt: item.updatedAt, 
      }));

      setgetData(formattedData)
    }
    handlegetActivisionData();
  }, []);
  
  return (
    <Layout>
      <div className='card mt-4 mb-2'>

        <div className='ml-3 mr-3'>
         


          {!showFormUpdate ? (
          <div>
            <div className=' mr-3 mt-3 mb-3'>
            <button className='btn btn-success' onClick={() => handleClearData() }>
              Cadastrar Motorista
            </button>
          </div>
            <input
              type="text"
              placeholder="Filtrar por nome ou e-mail"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              style={{
                marginBottom: "10px",
                padding: "8px",
                width: "18%",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
            <DataTable  
              columns={columns}
              data={filteredData}
              pagination
              onSelectedRowsChange={(selected) =>
                console.log("Selected Rows: ", selected.selectedRows)
              }

              paginationComponentOptions={{
                rowsPerPageText: 'Página',
                rangeSeparatorText: 'de',
                selectAllRowsItem: true,
                selectAllRowsItemText: 'Selecionar todos'
              }}
            />
          </div>
        ) :  <div className=''>
              <div className="modal-body">
                <form  method="POST">
                  <div className="row">
                    {/* Name */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nome"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Email */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="E-mail"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row">
                    {/* Address */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        id="address"
                        name="address"
                        className="form-control"
                        placeholder="Endereço"
                        value={formData.address}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Neighborhood */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        id="neighborhood"
                        name="neighborhood"
                        className="form-control"
                        placeholder="Bairro"
                        value={formData.neighborhood}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    {/* Postal Code */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        id="postal_code"
                        name="postal_code"
                        className="form-control"
                        placeholder="CEP"
                        value={formData.postal_code}
                        onChange={handleChangePostalcode}
                        required
                      />
                    </div>

                    {/* City */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        id="city"
                        name="city"
                        className="form-control"
                        placeholder="Cidade"
                        value={formData.city}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    {/* State */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        id="state"
                        name="state"
                        className="form-control"
                        placeholder="Estado"
                        value={formData.state}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Car Model */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        id="car_model"
                        name="car_model"
                        className="form-control"
                        placeholder="Modelo do Carro"
                        value={formData.car_model}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    {/* Transport Type - Select */}

                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        className="fadeIn second form-control"
                        name="number"
                        id="number"
                        placeholder="Número de Telefone"
                        value={formData.number}
                        onChange={maskPhone}
                        required
                      />
                    </div>
                    {/* Password */}
                    <div className="col-md-6 mb-3">
                      <input
                        type="password"
                        id="password"
                        name="password"
                        className="form-control"
                        placeholder="Senha"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row justify-content-left  ">
                    {/* Number */}
                    <div className="col-md-5 mb-3 ml-2">
                      <input
                        type="number"
                        id="pet_quantity"
                        name="pet_quantity"
                        className="form-control"
                        placeholder="Quantidade de Pets"
                        value={formData.pet_quantity}
                        onChange={handleChange}
                        min="0"
                      />
                    </div>

                    <div className="col-md-1">
                    </div>
                    <div className="col-md-5 mb-3 mr-2">
                      <select
                        id="transport_type"
                        name="transport_type"
                        className="form-control"
                        value={formData.transport_type}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Selecione...</option>
                        <option value="carro">Carro</option>
                        <option value="moto">Moto</option>
                      </select>
                    </div>
                  </div>
                  <div className='row container'>
                    <div className="col-md-5 mb-3">
                      <input
                        type="checkbox"
                        id="is_registered_in_app"
                        name="is_registered_in_app"
                        checked={formData.is_registered_in_app}
                        onChange={handleChange}
                        className="form-check-input"
                        placeholder='Registrado em algum App'
                      />

                        <span className='ml-3'>Registrado em algum App</span>
                    </div>
                  </div>
                </form>

                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setShowFormUpdate(false)}>Fechar</button>
                    <button className="btn btn-success" onClick={handleSubmitUpdate}>Editar</button>
                </div>
              </div>
            </div>}
          
        </div>
          {/* Modal do Bootstrap */}
          {(showModal && !showFormUpdate) && (
            <div className="modal fade show d-block">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Cadastrar Motorista</h5>
                            <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className="modal-body">
                            <form  method="POST">
                            <div className="row">
                                {/* Name */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    placeholder="Nome"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>

                                {/* Email */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    id="email"
                                    name="email"
                                    className="form-control"
                                    placeholder="E-mail"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="row">
                                {/* Address */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    id="address"
                                    name="address"
                                    className="form-control"
                                    placeholder="Endereço"
                                    value={formData.address}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>

                                {/* Neighborhood */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    id="neighborhood"
                                    name="neighborhood"
                                    className="form-control"
                                    placeholder="Bairro"
                                    value={formData.neighborhood}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="row">
                                {/* Postal Code */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    id="postal_code"
                                    name="postal_code"
                                    className="form-control"
                                    placeholder="CEP"
                                    value={formData.postal_code}
                                    onChange={handleChangePostalcode}
                                    required
                                  />
                                </div>

                                {/* City */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    id="city"
                                    name="city"
                                    className="form-control"
                                    placeholder="Cidade"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="row">
                                {/* State */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    id="state"
                                    name="state"
                                    className="form-control"
                                    placeholder="Estado"
                                    value={formData.state}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>

                                {/* Car Model */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    id="car_model"
                                    name="car_model"
                                    className="form-control"
                                    placeholder="Modelo do Carro"
                                    value={formData.car_model}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="row">
                                {/* Transport Type - Select */}

                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="fadeIn second form-control"
                                    name="number"
                                    id="number"
                                    placeholder="Número de Telefone"
                                    value={formData.number}
                                    onChange={maskPhone}
                                    required
                                  />
                                </div>
                                {/* Password */}
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="form-control"
                                    placeholder="Senha"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="row justify-content-left  ">
                                {/* Number */}
                                <div className="col-md-5 mb-3 ml-2">
                                  <input
                                    type="number"
                                    id="pet_quantity"
                                    name="pet_quantity"
                                    className="form-control"
                                    placeholder="Quantidade de Pets"
                                    value={formData.pet_quantity}
                                    onChange={handleChange}
                                    min="0"
                                  />
                                </div>

                                <div className="col-md-1">
                                </div>
                                <div className="col-md-5 mb-3 mr-2">
                                  <select
                                    id="transport_type"
                                    name="transport_type"
                                    className="form-control"
                                    value={formData.transport_type}
                                    onChange={handleChange}
                                    required
                                  >
                                    <option value="">Selecione...</option>
                                    <option value="carro">Carro</option>
                                    <option value="moto">Moto</option>
                                  </select>
                                </div>
                              </div>
                              <div className='row container'>
                                <div className="col-md-5 mb-3">
                                  <input
                                    type="checkbox"
                                    id="is_registered_in_app"
                                    name="is_registered_in_app"
                                    checked={formData.is_registered_in_app}
                                    onChange={handleChange}
                                    className="form-check-input"
                                    placeholder='Registrado em algum App'
                                  />

                                    <span className='ml-3'>Registrado em algum App</span>
                                </div>
                              </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Fechar</button>
                            <button className="btn btn-success" onClick={handleSubmit}>Salvar</button>
                        </div>
                    </div>
                </div>
            </div>
          )}

          {/* Background escuro (overlay) */}
          {(showModal && !showFormUpdate) && <div className="modal-backdrop fade show"></div>}
      </div>
    </Layout>
  );
   
};
export default ConfigMasterDrivePage;

